import { Box } from '@hivebrite/design-system/Box';
import { Loader } from '@hivebrite/design-system/Loader';

import { useSessionInfoContext } from 'hb-react/frontoffice/contexts/SessionInfoContext';
import MemberShipEmptyResult from 'hb-react/shared/apps/Memberships/components/MemberShipEmptyResult';
import MemberShipEmptyState from 'hb-react/shared/apps/Memberships/components/MemberShipEmptyState';
import NoMoreMembershipsToPurchase from 'hb-react/shared/apps/Memberships/components/NoMoreMembershipsToPurchase';
import { useQueryMemberships } from 'hb-react/shared/apps/Memberships/hooks//useQueryMemberships';

const NoMemberShips = ({ onResetFilters }) => {
  const { user_subscriptions_count: userSubscriptionCount, isLoading } =
    useQueryMemberships();

  const { memberships: membershipsSessionInfo } = useSessionInfoContext();
  const programme = membershipsSessionInfo?.programme;
  const { enable_cumulative_cart: enableCumulativeCart = false } =
    programme || {};

  const displayEmptyResult = enableCumulativeCart ? (
    <MemberShipEmptyState onResetFilters={onResetFilters} />
  ) : (
    <MemberShipEmptyResult />
  );

  if (userSubscriptionCount > 0) {
    if (isLoading) {
      return (
        <Box mt={5}>
          <Loader size={50} />
        </Box>
      );
    }

    return <NoMoreMembershipsToPurchase />;
  }

  return isLoading ? (
    <Box mt={5}>
      <Loader size={50} />
    </Box>
  ) : (
    displayEmptyResult
  );
};

export default NoMemberShips;
